import React from 'react';

import CustomChart from '../../../components/CustomChart/CustomChart'
import { _emotionalTendencyPolar } from '../../../chart';
import { CustomizedForm } from '../components/baseForm'
import baseFiled from '../components/baseFiled';
import FavorForm from './FavorForm';
import data from './data.json'

const checkPx = (str) => {
  let _str = str + '';
  if (_str.indexOf('%')) {
    return _str;
  } else {
    return _str + 'px'
  }
}

class Favor extends React.Component {
  state = {
    fields: {
      ...Object.assign(baseFiled, {
        titleText: {
          value: '暴风影音受众好感图'
        },
        subTitleText: {
          value: '2019.11.20-2019.12.05'
        }
      })      
    },
    list: data,
    colorList: [{
      name: '顺意群体',
      value: 'agreeable',
      color: '#676767'
    }, {
      name: '中立群体',
      value: 'neutrality',
      color: '#bfbebf'
    }, {
      name: '逆意群体',
      value: 'reverse',
      color: '#9b9b9b'
    }],
    chartWidth: '100%',
    chartHeight: '100%',
    chart: _emotionalTendencyPolar(),
  }

  componentDidMount () {
    this.init()
  }

  init = () => {
    const {fields, list, colorList} = this.state;
    const chart = _emotionalTendencyPolar({
      ...fields,
      list,
      colorList
    });

    this.setState({
      chartHeight: checkPx(fields.chartHeight.value),
      chartWidth: checkPx(fields.chartWidth.value),
      chart: chart
    })
  }

  handleFormChange = (props, changedFields) => {
    this.setState(({ fields }) => ({
      fields: {
        ...fields,
        ...changedFields
      }
    }));
  }

  handleAdd = (props, changedFields) => {

    if (Array.isArray(changedFields)) {
      this.setState({
        list: changedFields
      })
    } else {
      const colorList = this.state.colorList;
      const color = changedFields.color;
      
      color.forEach((item, index) => {
        
        colorList[index].color = item.value
      });

      this.setState({
        colorList: colorList
      })

    }
  }


  render() {
    const {fields, list, colorList, chartWidth, chartHeight} = this.state;
    return (
      <CustomChart 
        width={chartWidth} 
        height={chartHeight} 
        chart={this.state.chart}
        callback={this.init}
      >
        <FavorForm list={list} color={colorList} onChange={this.handleAdd} />
        <CustomizedForm {...fields} onChange={this.handleFormChange} />
      </CustomChart>
    );
  }
}

export default Favor



// WEBPACK FOOTER //
// src/routes/customChart/Favor/Favor.js